var map = {
	"./Sonar-dark.svg": 1844,
	"./Sonar.svg": 5860,
	"./ada-dark.svg": 9014,
	"./ada.svg": 4766,
	"./analysis.png": 877,
	"./assembly.png": 944,
	"./c++.svg": 6611,
	"./c.svg": 9723,
	"./c3.svg": 4205,
	"./carbon.png": 7874,
	"./circt.svg": 8537,
	"./clean.svg": 9711,
	"./cmake.svg": 9530,
	"./crystal-dark.svg": 5844,
	"./crystal.svg": 6643,
	"./cuda-dark.svg": 6397,
	"./cuda.svg": 2912,
	"./d.svg": 5779,
	"./dart.svg": 3725,
	"./dotnet.svg": 2130,
	"./erlang.svg": 1217,
	"./fortran.svg": 8218,
	"./fsharp.svg": 2583,
	"./go.svg": 6593,
	"./haskell.png": 4524,
	"./hlsl.png": 6137,
	"./hook.png": 4607,
	"./ispc.png": 4634,
	"./java.svg": 6199,
	"./js.svg": 4786,
	"./julia.svg": 2117,
	"./kotlin.svg": 3519,
	"./llvm.png": 2722,
	"./mlir.svg": 5102,
	"./nim.svg": 5961,
	"./ocaml.svg": 6130,
	"./opencl-dark.svg": 7589,
	"./opencl.svg": 555,
	"./pascal-dark.svg": 636,
	"./pascal.svg": 7943,
	"./pony.svg": 2241,
	"./python.svg": 5380,
	"./racket.svg": 4882,
	"./ruby.svg": 4621,
	"./rust-dark.svg": 2066,
	"./rust.svg": 5545,
	"./scala.png": 2209,
	"./snowball.svg": 2644,
	"./solidity.svg": 2018,
	"./swift.svg": 9935,
	"./toit.svg": 2788,
	"./ts.svg": 9345,
	"./v.svg": 9356,
	"./vala.svg": 1841,
	"./zig.svg": 283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8933;